import { observable, ObservableMap, autorun } from "mobx";
import { diResolve, diContainers } from './diContext'
import * as str from "utils/string";
export class I18nService {
    default;
    configs = {};
    /**
     * 初始化默认预言配置
     * @param configs
     * @param defaults
     */
    init(configs, init_language = "en-US") {
        this.default = configs.default || configs[init_language];
        this.configs = configs;
        return this;
    }
    /**
     * 添加语言配置
     * @param configs
     */
    add(configs) {
        this.default = { ...this.default, ...configs.default };
        for (var name in configs) {
            var last_config = this.configs[name];
            if (!last_config) {
                last_config = {};
            }
            var new_config = configs[name];
            this.configs[name] = { ...last_config, ...new_config }
        }
    }
    L<T>(key, params: any, lang = "en-US"): any{
        var langConf = this.configs[lang];
        var val = langConf && langConf[key];
        if (!val) {
            val = this.default[key];
        }
        if (params) {
            val = str.Format(val, params);
        }
        return val;
    }
}


// WEBPACK FOOTER //
// ./src/stores/i18n.ts